export default __webpack_public_path__ + "static/media/ie_loader.4d6d4b68.gif";